module.exports = "/assets/data/0e92f4ea7cfe20ffe132dba33b25ecf3-CA23.data.json";